import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { Checkbox, Toggle, IToggleSide } from 'components/action';

// Styles
const s = require('styles/sales/sales');

// Props
interface IQuestionOptionRadioProps {
  onChange: (value: IToggleSide) => void;
  options: string[];
  value: any;
}

// Component
@observer
export class QuestionOptionRadio extends React.Component<
  IQuestionOptionRadioProps,
  {}
> {
  constructor(props: IQuestionOptionRadioProps) {
    super(props);
  }

  @computed private get options(): string[] | null {
    return typeof this.props.options !== 'undefined' && this.props.options
      ? typeof this.props.options === 'object'
        ? typeof this.props.options.length !== 'undefined'
          ? this.props.options
          : Object.keys(this.props.options)
        : null
      : null;
  }

  @computed private get optionsLength(): number {
    return this.options !== null ? this.options.length : 0;
  }

  public render() {
    return this.optionsLength > 0 && this.optionsLength <= 2
      ? this.renderYesOrNoToggle()
      : this.optionsLength > 0
      ? this.renderMoreOptions()
      : null;
  }

  private renderYesOrNoToggle() {
    return (
      <Toggle
        onChange={this.handleToggleChange}
        left={{
          value: 0,
          label: this.props.options[0],
          type: 'default',
        }}
        right={{
          value: 1,
          label: this.props.options[1],
          type: 'success',
        }}
        value={this.props.value}
      />
    );
  }

  private handleToggleChange = (value: IToggleSide | null) => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  private renderMoreOptions() {
    return (
      <div>
        {this.options.map((option, i) => {
          return (
            <Checkbox
              key={`option-${i}`}
              onChange={this.handleRadioChange}
              checked={this.props.value === option}
              value={option}
              valueUnchecked={false}
              label={option}
            />
          );
        })}
      </div>
    );
  }

  private handleRadioChange = (checked: boolean, value: any) => {
    if (this.props.onChange) {
      this.props.onChange({
        value,
        label: value,
        type: 'default',
      });
    }
  };
}

export default QuestionOptionRadio;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionRadio.tsx